var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-2 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.32,34.67c4.1,4.1,4.1,10.75,0,14.84l-10.91,10.91c-4.1,4.1-10.75,4.1-14.84,0s-4.1-10.75,0-14.84l10.91-10.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m34.68,40.32c-4.1-4.1-4.1-10.75,0-14.84l10.91-10.91c4.1-4.1,10.75-4.1,14.84,0,4.1,4.1,4.1,10.75,0,14.84l-10.91,10.91"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lin"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 12.2,
    y: 0
  }, "k"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/__Link.d0e92b7ae56c49e3fb25eb2e2b046840.svg";
export { ForwardRef as ReactComponent };